import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useOcurrencesChartsDataContext } from './hooks/useOcurrencesChartsDataContext';

export const OcurrenceByForwarding = () => {
    const { chartData } = useOcurrencesChartsDataContext();

    return (
        <SimpleBars
            title={'Ocorrências com regulação por encaminhamento (5+)'}
            horizontal={false}
            subtitles={chartData?.ocurrenceByForwarding?.map((item) => item.description)}
            values={chartData?.ocurrenceByForwarding?.map((item) => item.total || 0)}
            stacked
        />
    );
};